/**
 * go.tvunetworks.com 支付页埋点编排 —— SPAR-593
 * 事件名与参数取值由 PM 定义，改动前先对齐 SPAR-593
 */
import { initGa, setGaUserId, trackEvent, mapPlan } from '@/common/ga'

/**
 * 页面挂载时初始化 GA4 并绑定 user_id
 * user_id 是 Web 事件关联回 Android App 用户的唯一手段（两者属不同数据流）
 * @param {string} [userId] TVU userId
 */
export function initWebAppTracking (userId) {
  initGa()
  setGaUserId(userId)
}

/** 定价页加载 */
export function trackPricingScreenViewed () {
  trackEvent('pricing_screen_viewed')
}

/**
 * 用户选中套餐
 * @param {string} planId
 */
export function trackPlanSelected (planId) {
  trackEvent('plan_selected', { plan: mapPlan(planId) })
}

/**
 * 用户进入支付确认步骤
 * 注意：Stripe Embedded Checkout 的支付按钮在跨域 iframe 内，前端无法监听真实的
 * "点击确认支付"，Stripe 也未暴露对应回调。此处以「支付表单挂载成功」为触发点，
 * 语义上等于「用户到达支付步骤」，漏斗解读需知悉该口径（待 PM 最终确认）。
 * @param {string} planId
 */
export function trackPaymentMethodConfirmed (planId) {
  trackEvent('payment_method_confirmed', { plan: mapPlan(planId) })
}

/**
 * 支付成功
 * platform 按 SPAR-593 规范固定为 android（该页同时服务 iOS/桌面浏览器，口径待 PM 确认）
 * @param {object} params
 * @param {string} params.planId
 * @param {string} [params.userId] TVU userId，缺失时不上报该参数，避免污染为 undefined
 */
export function trackTrialStarted ({ planId, userId } = {}) {
  const params = {
    plan: mapPlan(planId),
    platform: 'android',
    payment_provider: 'stripe'
  }
  if (userId) params.user_id = userId
  trackEvent('trial_started', params)
}
